import { t } from '@i18n';

/**
 * File validation constants
 */
export const FileValidation = {
    MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB in bytes
    ACCEPTED_TYPES: ['application/pdf'],
    ACCEPTED_EXTENSIONS: ['.pdf'],
};

/**
 * File size units
 */
export const FileSizeUnits = ['B', 'KB', 'MB', 'GB'];

/**
 * Validation messages.
 * Getters resolve at read time so the message follows the active language —
 * a plain object literal would freeze the copy at import time.
 */
export const ValidationMessages = {
    get INVALID_FILE_TYPE() { return t('contentModals:manageMaterial.file.invalidType'); },
    get FILE_TOO_LARGE() { return t('contentModals:manageMaterial.file.tooLarge'); },
    get FILE_READ_ERROR() { return t('contentModals:manageMaterial.file.readError'); },
    get MATERIAL_REQUIRED() { return t('contentModals:manageMaterial.file.required'); },
    get TITLE_REQUIRED() { return t('contentModals:manageMaterial.file.titleRequired'); },
};
